module.exports = __webpack_public_path__ + "static/media/Q_2.3fdda45d.png";